import { render, staticRenderFns } from "./mrc_ess_multiTextarea.vue?vue&type=template&id=2bbb36c6&scoped=true&"
import script from "./mrc_ess_multiTextarea.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_multiTextarea.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_multiTextarea.vue?vue&type=style&index=0&id=2bbb36c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb36c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardText,VForm,VList,VListItem,VMenu,VTextarea})
